const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#ba192e",
    d: "M 303.5,48.5 C 305.246,49.2176 305.912,50.2176 305.5,51.5C 307.071,50.6906 308.738,50.3573 310.5,50.5C 322.054,53.444 333.054,57.7774 343.5,63.5C 343.821,65.0481 344.821,65.7148 346.5,65.5C 348.784,65.9752 350.784,66.9752 352.5,68.5C 352.821,70.0481 353.821,70.7148 355.5,70.5C 358.54,71.6803 361.206,73.347 363.5,75.5C 364.035,77.4456 365.368,78.4456 367.5,78.5C 367.877,80.8241 368.877,81.4908 370.5,80.5C 371.035,82.4456 372.368,83.4456 374.5,83.5C 376.754,84.1237 378.421,85.457 379.5,87.5C 380.991,88.9131 381.658,90.4131 381.5,92C 382.793,92.49 384.127,92.6567 385.5,92.5C 389.12,94.4528 392.12,97.1195 394.5,100.5C 396.5,103.167 398.833,105.5 401.5,107.5C 403.5,108.833 405.167,110.5 406.5,112.5C 406.738,114.404 407.738,115.738 409.5,116.5C 410.5,116.833 411.167,117.5 411.5,118.5C 411.427,120.027 412.094,121.027 413.5,121.5C 415.262,122.262 416.262,123.596 416.5,125.5C 416.738,127.404 417.738,128.738 419.5,129.5C 419.427,131.027 420.094,132.027 421.5,132.5C 421.427,134.027 422.094,135.027 423.5,135.5C 423.427,137.027 424.094,138.027 425.5,138.5C 426.338,138.842 426.672,139.508 426.5,140.5C 426.427,142.027 427.094,143.027 428.5,143.5C 429.338,143.842 429.672,144.508 429.5,145.5C 429.427,147.027 430.094,148.027 431.5,148.5C 440.962,164.432 447.962,181.432 452.5,199.5C 452.259,201.898 452.926,203.898 454.5,205.5C 455.301,207.042 455.634,208.708 455.5,210.5C 455.259,212.898 455.926,214.898 457.5,216.5C 466.384,272.58 456.217,324.914 427,373.5C 423.637,378.35 420.137,383.017 416.5,387.5C 411.677,387.327 409.677,389.661 410.5,394.5C 410.5,395.167 410.167,395.5 409.5,395.5C 408.094,395.973 407.427,396.973 407.5,398.5C 405.833,400.833 403.833,402.833 401.5,404.5C 400.934,402.922 399.934,401.588 398.5,400.5C 398.642,402.694 398.309,405.027 397.5,407.5C 395.54,408.138 393.707,408.138 392,407.5C 392.499,408.894 393.333,410.228 394.5,411.5C 388.778,417.555 382.444,422.889 375.5,427.5C 373.833,427.5 372.167,427.5 370.5,427.5C 370.5,428.833 370.5,430.167 370.5,431.5C 326.098,462.179 277.098,473.512 223.5,465.5C 220.781,464.087 217.781,463.42 214.5,463.5C 212.379,463.675 210.379,463.341 208.5,462.5C 206.898,460.926 204.898,460.259 202.5,460.5C 193.456,458.648 184.79,455.648 176.5,451.5C 172.156,439.616 169.656,427.282 169,414.5C 167.036,390.804 168.869,367.47 174.5,344.5C 176.074,342.898 176.741,340.898 176.5,338.5C 179.889,324.72 185.222,311.72 192.5,299.5C 192.333,299.167 192.167,298.833 192,298.5C 185.929,305.064 180.096,311.73 174.5,318.5C 173.042,318.579 171.708,319.079 170.5,320C 171.252,320.671 171.586,321.504 171.5,322.5C 151.099,352.358 138.765,385.358 134.5,421.5C 133.833,421.833 133.167,422.167 132.5,422.5C 129.467,420.984 126.8,418.984 124.5,416.5C 123.738,414.738 122.404,413.738 120.5,413.5C 118.5,412.167 116.833,410.5 115.5,408.5C 113.833,406.167 111.833,404.167 109.5,402.5C 106.833,400.5 104.5,398.167 102.5,395.5C 102.5,394.167 101.833,393.5 100.5,393.5C 99.5,392.167 98.5,390.833 97.5,389.5C 97.573,387.973 96.9063,386.973 95.5,386.5C 91.7621,383.09 88.7621,379.09 86.5,374.5C 86.4456,372.368 85.4456,371.035 83.5,370.5C 82.3871,369.054 82.2204,367.387 83,365.5C 87.3968,354.375 92.5634,343.709 98.5,333.5C 99.9063,333.027 100.573,332.027 100.5,330.5C 100.328,329.508 100.662,328.842 101.5,328.5C 102.906,328.027 103.573,327.027 103.5,325.5C 103.328,324.508 103.662,323.842 104.5,323.5C 105.906,323.027 106.573,322.027 106.5,320.5C 107.906,320.027 108.573,319.027 108.5,317.5C 109.906,317.027 110.573,316.027 110.5,314.5C 112.262,313.738 113.262,312.404 113.5,310.5C 116.411,305.254 120.078,300.587 124.5,296.5C 126.587,295.415 127.92,293.749 128.5,291.5C 131.167,288.167 134.167,285.167 137.5,282.5C 141.41,280.263 144.743,277.263 147.5,273.5C 150.089,272.581 152.089,270.914 153.5,268.5C 155.404,268.262 156.738,267.262 157.5,265.5C 159.404,265.262 160.738,264.262 161.5,262.5C 163.027,262.573 164.027,261.906 164.5,260.5C 166.027,260.573 167.027,259.906 167.5,258.5C 169.027,258.573 170.027,257.906 170.5,256.5C 170.842,255.662 171.508,255.328 172.5,255.5C 174.027,255.573 175.027,254.906 175.5,253.5C 176.514,252.326 177.847,251.66 179.5,251.5C 181.027,251.573 182.027,250.906 182.5,249.5C 186.586,247.13 190.919,245.13 195.5,243.5C 197.698,243.88 199.365,243.213 200.5,241.5C 202.698,241.88 204.365,241.213 205.5,239.5C 207.993,238.226 210.659,237.56 213.5,237.5C 216.152,237.59 218.485,236.924 220.5,235.5C 227.827,232.904 235.494,231.571 243.5,231.5C 247.139,230.732 246.806,230.066 242.5,229.5C 199.58,222.952 159.247,230.285 121.5,251.5C 119.473,251.338 117.473,251.505 115.5,252C 117.619,252.342 117.953,253.175 116.5,254.5C 105.908,261.75 95.5752,269.416 85.5,277.5C 84.1266,277.343 82.7932,277.51 81.5,278C 82.5981,278.77 82.5981,279.603 81.5,280.5C 76.1667,286.5 70.5,292.167 64.5,297.5C 63.0937,297.973 62.427,298.973 62.5,300.5C 61.3367,303.238 59.5033,304.238 57,303.5C 50.4998,279.512 48.8331,255.179 52,230.5C 66.8915,222.636 82.3915,216.303 98.5,211.5C 100.898,211.741 102.898,211.074 104.5,209.5C 104.833,209.5 105.167,209.5 105.5,209.5C 108.152,209.59 110.485,208.924 112.5,207.5C 114.898,207.741 116.898,207.074 118.5,205.5C 162.752,193.802 207.418,191.802 252.5,199.5C 253.601,200.598 254.934,200.765 256.5,200C 255.956,199.283 255.289,198.783 254.5,198.5C 252.566,197.89 250.899,196.89 249.5,195.5C 248.656,193.241 246.989,192.241 244.5,192.5C 232.293,186.32 219.626,181.32 206.5,177.5C 204.562,175.837 202.228,175.171 199.5,175.5C 192.823,174.499 186.156,173.499 179.5,172.5C 177.708,171.691 175.708,171.191 173.5,171C 185.801,169.748 198.134,169.248 210.5,169.5C 236.355,169.232 261.689,172.732 286.5,180C 292.214,181.509 297.548,183.675 302.5,186.5C 302.427,188.027 303.094,189.027 304.5,189.5C 304.427,191.027 305.094,192.027 306.5,192.5C 308.262,193.262 309.262,194.596 309.5,196.5C 309.738,198.404 310.738,199.738 312.5,200.5C 313.5,200.833 314.167,201.5 314.5,202.5C 314.427,204.027 315.094,205.027 316.5,205.5C 318.823,208.126 321.157,210.793 323.5,213.5C 323.783,214.289 324.283,214.956 325,215.5C 325.494,213.866 325.66,212.199 325.5,210.5C 325.368,199.027 328.035,188.36 333.5,178.5C 334.906,178.027 335.573,177.027 335.5,175.5C 336.906,175.027 337.573,174.027 337.5,172.5C 338.906,172.027 339.573,171.027 339.5,169.5C 339.833,168.5 340.5,167.833 341.5,167.5C 342.922,166.075 344.589,165.075 346.5,164.5C 347.338,164.842 347.672,165.508 347.5,166.5C 347.427,168.027 348.094,169.027 349.5,169.5C 349.427,171.027 350.094,172.027 351.5,172.5C 351.427,174.027 352.094,175.027 353.5,175.5C 353.427,177.027 354.094,178.027 355.5,178.5C 355.738,180.404 356.738,181.738 358.5,182.5C 358.738,184.404 359.738,185.738 361.5,186.5C 362.08,188.749 363.413,190.415 365.5,191.5C 366.5,191.833 367.167,192.5 367.5,193.5C 367.738,195.404 368.738,196.738 370.5,197.5C 372.167,198.5 373.5,199.833 374.5,201.5C 377.833,206.833 382.167,211.167 387.5,214.5C 389.167,215.5 390.5,216.833 391.5,218.5C 392.035,220.446 393.368,221.446 395.5,221.5C 396.65,223.267 395.983,224.433 393.5,225C 386.822,228.282 379.822,230.449 372.5,231.5C 370.712,231.215 369.045,231.548 367.5,232.5C 367.624,233.107 367.957,233.44 368.5,233.5C 370.5,234.833 372.167,236.5 373.5,238.5C 377.5,243.167 381.833,247.5 386.5,251.5C 388.833,253.167 390.833,255.167 392.5,257.5C 393.08,259.749 394.413,261.415 396.5,262.5C 397.5,262.833 398.167,263.5 398.5,264.5C 398.738,266.404 399.738,267.738 401.5,268.5C 401.631,269.239 401.464,269.906 401,270.5C 400.329,269.748 399.496,269.414 398.5,269.5C 397.508,269.672 396.842,269.338 396.5,268.5C 395.738,266.738 394.404,265.738 392.5,265.5C 392.027,264.094 391.027,263.427 389.5,263.5C 389.027,262.094 388.027,261.427 386.5,261.5C 385.508,261.672 384.842,261.338 384.5,260.5C 384.027,259.094 383.027,258.427 381.5,258.5C 379.181,258.008 377.181,257.008 375.5,255.5C 375.027,254.094 374.027,253.427 372.5,253.5C 359.574,247.753 346.574,242.42 333.5,237.5C 331.898,235.926 329.898,235.259 327.5,235.5C 325.708,235.634 324.042,235.301 322.5,234.5C 320.162,232.96 317.495,232.294 314.5,232.5C 314.167,232.5 313.833,232.5 313.5,232.5C 310.373,231.419 307.04,230.753 303.5,230.5C 301.372,229.371 299.039,229.204 296.5,230C 298.518,230.505 300.518,231.005 302.5,231.5C 306.381,232.903 310.381,233.903 314.5,234.5C 322.126,236.595 329.459,239.262 336.5,242.5C 337.78,243.931 339.447,244.598 341.5,244.5C 351.928,248.213 361.595,253.213 370.5,259.5C 371.634,262.034 373.634,263.367 376.5,263.5C 378.404,263.738 379.738,264.738 380.5,266.5C 381.865,268.86 383.865,270.527 386.5,271.5C 387.08,273.749 388.413,275.415 390.5,276.5C 390.738,278.404 391.738,279.738 393.5,280.5C 395.715,283.903 396.048,287.57 394.5,291.5C 389.968,291.379 389.634,292.712 393.5,295.5C 395.403,295.796 397.07,296.463 398.5,297.5C 400.679,298.926 403.179,299.592 406,299.5C 407.707,299.492 409.207,299.158 410.5,298.5C 412.649,297.264 414.982,296.264 417.5,295.5C 420.335,294.931 422.001,293.264 422.5,290.5C 426.22,283.619 427.72,276.286 427,268.5C 422.68,252.361 416.513,237.028 408.5,222.5C 408.253,220.142 408.919,218.142 410.5,216.5C 411.586,216.38 412.253,215.713 412.5,214.5C 412.457,213.584 412.124,212.917 411.5,212.5C 406.849,203.868 402.183,195.201 397.5,186.5C 397.715,184.821 397.048,183.821 395.5,183.5C 390.867,176.523 386.2,169.523 381.5,162.5C 381.446,160.368 380.446,159.035 378.5,158.5C 377.833,158.5 377.5,158.167 377.5,157.5C 377.446,155.368 376.446,154.035 374.5,153.5C 371.862,150.526 369.195,147.526 366.5,144.5C 366.573,142.973 365.906,141.973 364.5,141.5C 358.5,136.167 352.833,130.5 347.5,124.5C 346.738,122.738 345.404,121.738 343.5,121.5C 341.833,120.5 340.5,119.167 339.5,117.5C 339.027,116.094 338.027,115.427 336.5,115.5C 334.091,114.299 332.091,112.633 330.5,110.5C 330.027,109.094 329.027,108.427 327.5,108.5C 326.738,106.738 325.404,105.738 323.5,105.5C 321.566,104.89 319.899,103.89 318.5,102.5C 318.027,101.094 317.027,100.427 315.5,100.5C 314.508,100.672 313.842,100.338 313.5,99.5C 312.656,97.2407 310.989,96.2407 308.5,96.5C 306.181,96.0075 304.181,95.0075 302.5,93.5C 302.44,92.9569 302.107,92.6236 301.5,92.5C 300.227,93.2565 300.227,93.9232 301.5,94.5C 304.98,100.464 307.647,106.797 309.5,113.5C 309.631,114.239 309.464,114.906 309,115.5C 308.329,114.748 307.496,114.414 306.5,114.5C 306.027,113.094 305.027,112.427 303.5,112.5C 301.847,112.34 300.514,111.674 299.5,110.5C 299.027,109.094 298.027,108.427 296.5,108.5C 285.765,103.795 275.098,99.1281 264.5,94.5C 263.365,92.7868 261.698,92.1201 259.5,92.5C 258.209,92.7373 257.209,92.404 256.5,91.5C 254.898,89.9261 252.898,89.2594 250.5,89.5C 247.659,89.4403 244.993,88.7736 242.5,87.5C 237.899,85.098 232.899,83.7647 227.5,83.5C 225.585,83.7845 223.919,83.4511 222.5,82.5C 218.79,80.8643 214.79,80.1977 210.5,80.5C 189.203,78.237 167.869,77.9036 146.5,79.5C 145.209,79.7373 144.209,79.404 143.5,78.5C 145.027,78.573 146.027,77.9063 146.5,76.5C 147.659,74.7497 149.326,73.7497 151.5,73.5C 153.027,73.573 154.027,72.9063 154.5,71.5C 157.32,71.913 159.32,70.913 160.5,68.5C 167.067,64.3846 174.067,61.0512 181.5,58.5C 183.807,58.0137 185.973,58.0137 188,58.5C 188.513,57.4734 189.013,56.4734 189.5,55.5C 194.165,54.9431 198.498,53.6098 202.5,51.5C 205.152,51.5905 207.485,50.9238 209.5,49.5C 240.742,40.5647 272.076,40.2314 303.5,48.5 Z M 347.5,212.5 C 346.5,210.833 345.167,209.5 343.5,208.5C 343.753,202.822 345.253,197.489 348,192.5C 348.718,191.549 349.551,191.383 350.5,192C 352.167,193.667 353.833,195.333 355.5,197C 351.949,202.288 350.949,207.955 352.5,214C 350.718,214.122 349.052,213.622 347.5,212.5 Z M 350.5,265.5 C 352.599,266.612 354.933,267.279 357.5,267.5C 361.433,269.033 365.433,270.367 369.5,271.5C 369.973,272.906 370.973,273.573 372.5,273.5C 378.38,276.922 380.713,281.922 379.5,288.5C 378.094,288.973 377.427,289.973 377.5,291.5C 376.167,292.167 375.167,293.167 374.5,294.5C 371.996,296.144 369.329,297.644 366.5,299C 364.689,300.041 364.355,301.207 365.5,302.5C 365.973,303.906 366.973,304.573 368.5,304.5C 372.377,307.129 376.71,308.796 381.5,309.5C 381.833,309.5 382.167,309.5 382.5,309.5C 385.219,310.913 388.219,311.58 391.5,311.5C 393.344,312.204 393.844,313.537 393,315.5C 390.096,322.971 386.93,330.305 383.5,337.5C 382.094,337.973 381.427,338.973 381.5,340.5C 380.11,341.899 379.11,343.566 378.5,345.5C 376.738,346.262 375.738,347.596 375.5,349.5C 373.738,350.262 372.738,351.596 372.5,353.5C 370.833,354.5 369.5,355.833 368.5,357.5C 366.367,359.091 364.701,361.091 363.5,363.5C 361.167,365.167 359.167,367.167 357.5,369.5C 354.573,370.757 352.239,372.757 350.5,375.5C 348.251,376.08 346.585,377.413 345.5,379.5C 343.596,379.738 342.262,380.738 341.5,382.5C 339.973,382.427 338.973,383.094 338.5,384.5C 334.628,386.597 330.961,388.931 327.5,391.5C 325.973,391.427 324.973,392.094 324.5,393.5C 314.645,393.214 305.312,390.881 296.5,386.5C 296.027,385.094 295.027,384.427 293.5,384.5C 288.23,380.569 283.23,376.236 278.5,371.5C 278.262,369.596 277.262,368.262 275.5,367.5C 275.573,365.973 274.906,364.973 273.5,364.5C 272.18,361.86 270.847,359.193 269.5,356.5C 269.008,354.181 268.008,352.181 266.5,350.5C 256.287,316.818 264.621,288.818 291.5,266.5C 292.833,265.833 293.833,264.833 294.5,263.5C 313.221,261.953 331.888,262.62 350.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#7a3a41",
    d: "M 209.5,49.5 C 207.485,50.9238 205.152,51.5905 202.5,51.5C 204.515,50.0762 206.848,49.4095 209.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#7c2a2e",
    d: "M 303.5,48.5 C 306.067,48.7215 308.401,49.3882 310.5,50.5C 308.738,50.3573 307.071,50.6906 305.5,51.5C 305.912,50.2176 305.246,49.2176 303.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#6c343a",
    d: "M 202.5,51.5 C 198.498,53.6098 194.165,54.9431 189.5,55.5C 193.502,53.3902 197.835,52.0569 202.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#773135",
    d: "M 189.5,55.5 C 189.013,56.4734 188.513,57.4734 188,58.5C 185.973,58.0137 183.807,58.0137 181.5,58.5C 183.936,57.129 186.603,56.129 189.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#612125",
    d: "M 343.5,63.5 C 344.71,63.9321 345.71,64.5987 346.5,65.5C 344.821,65.7148 343.821,65.0481 343.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.929
    },
    fill: "#5d2121",
    d: "M 352.5,68.5 C 353.71,68.9321 354.71,69.5987 355.5,70.5C 353.821,70.7148 352.821,70.0481 352.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#853539",
    d: "M 160.5,68.5 C 159.32,70.913 157.32,71.913 154.5,71.5C 156.181,69.9925 158.181,68.9925 160.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.784
    },
    fill: "#5c3b3f",
    d: "M 154.5,71.5 C 154.027,72.9063 153.027,73.573 151.5,73.5C 151.973,72.0937 152.973,71.427 154.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#592224",
    d: "M 363.5,75.5 C 365.23,76.0256 366.564,77.0256 367.5,78.5C 365.368,78.4456 364.035,77.4456 363.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.827
    },
    fill: "#6a4045",
    d: "M 146.5,76.5 C 146.027,77.9063 145.027,78.573 143.5,78.5C 143.973,77.0937 144.973,76.427 146.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.639
    },
    fill: "#4b3539",
    d: "M 143.5,78.5 C 144.209,79.404 145.209,79.7373 146.5,79.5C 144.965,80.7879 143.299,80.7879 141.5,79.5C 141.957,78.7025 142.624,78.3691 143.5,78.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#622225",
    d: "M 367.5,78.5 C 369.027,78.427 370.027,79.0937 370.5,80.5C 368.877,81.4908 367.877,80.8241 367.5,78.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.757
    },
    fill: "#593034",
    d: "M 210.5,80.5 C 214.79,80.1977 218.79,80.8643 222.5,82.5C 218.295,82.2833 214.295,81.6167 210.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#5c2326",
    d: "M 370.5,80.5 C 372.23,81.0256 373.564,82.0256 374.5,83.5C 372.368,83.4456 371.035,82.4456 370.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.863
    },
    fill: "#4e2a2c",
    d: "M 227.5,83.5 C 232.899,83.7647 237.899,85.098 242.5,87.5C 237.272,86.6113 232.272,85.278 227.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.902
    },
    fill: "#5e2c30",
    d: "M 250.5,89.5 C 252.898,89.2594 254.898,89.9261 256.5,91.5C 254.214,91.405 252.214,90.7384 250.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#8b252d",
    d: "M 379.5,87.5 C 382.109,88.4431 384.109,90.1097 385.5,92.5C 384.127,92.6567 382.793,92.49 381.5,92C 381.658,90.4131 380.991,88.9131 379.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#642b30",
    d: "M 259.5,92.5 C 261.698,92.1201 263.365,92.7868 264.5,94.5C 262.597,94.2041 260.93,93.5375 259.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.118
    },
    fill: "#191414",
    d: "M 302.5,93.5 C 301.833,93.5 301.5,93.8333 301.5,94.5C 300.227,93.9232 300.227,93.2565 301.5,92.5C 302.107,92.6236 302.44,92.9569 302.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#75242a",
    d: "M 308.5,96.5 C 310.989,96.2407 312.656,97.2407 313.5,99.5C 311.566,98.8897 309.899,97.8897 308.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3c1f23",
    d: "M 394.5,100.5 C 397.833,101.833 400.167,104.167 401.5,107.5C 398.833,105.5 396.5,103.167 394.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#442224",
    d: "M 315.5,100.5 C 317.027,100.427 318.027,101.094 318.5,102.5C 316.973,102.573 315.973,101.906 315.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.671
    },
    fill: "#5c2327",
    d: "M 323.5,105.5 C 325.404,105.738 326.738,106.738 327.5,108.5C 325.596,108.262 324.262,107.262 323.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.18
    },
    fill: "#331b1d",
    d: "M 296.5,108.5 C 298.027,108.427 299.027,109.094 299.5,110.5C 297.973,110.573 296.973,109.906 296.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.537
    },
    fill: "#572125",
    d: "M 327.5,108.5 C 329.027,108.427 330.027,109.094 330.5,110.5C 328.973,110.573 327.973,109.906 327.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#452327",
    d: "M 303.5,112.5 C 305.027,112.427 306.027,113.094 306.5,114.5C 304.973,114.573 303.973,113.906 303.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#582328",
    d: "M 406.5,112.5 C 408.262,113.262 409.262,114.596 409.5,116.5C 407.738,115.738 406.738,114.404 406.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.216
    },
    fill: "#2c1b1c",
    d: "M 309.5,113.5 C 310.404,114.209 310.737,115.209 310.5,116.5C 308.62,116.771 307.287,116.104 306.5,114.5C 307.496,114.414 308.329,114.748 309,115.5C 309.464,114.906 309.631,114.239 309.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.745
    },
    fill: "#541f23",
    d: "M 336.5,115.5 C 338.027,115.427 339.027,116.094 339.5,117.5C 337.973,117.573 336.973,116.906 336.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.792
    },
    fill: "#5a252b",
    d: "M 411.5,118.5 C 412.906,118.973 413.573,119.973 413.5,121.5C 412.094,121.027 411.427,120.027 411.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.639
    },
    fill: "#441d21",
    d: "M 343.5,121.5 C 345.404,121.738 346.738,122.738 347.5,124.5C 345.596,124.262 344.262,123.262 343.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.929
    },
    fill: "#65272b",
    d: "M 416.5,125.5 C 418.262,126.262 419.262,127.596 419.5,129.5C 417.738,128.738 416.738,127.404 416.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.522
    },
    fill: "#59292e",
    d: "M 419.5,129.5 C 420.906,129.973 421.573,130.973 421.5,132.5C 420.094,132.027 419.427,131.027 419.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.459
    },
    fill: "#552b2e",
    d: "M 421.5,132.5 C 422.906,132.973 423.573,133.973 423.5,135.5C 422.094,135.027 421.427,134.027 421.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#442528",
    d: "M 423.5,135.5 C 424.906,135.973 425.573,136.973 425.5,138.5C 424.094,138.027 423.427,137.027 423.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#30181a",
    d: "M 364.5,141.5 C 365.906,141.973 366.573,142.973 366.5,144.5C 365.094,144.027 364.427,143.027 364.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.404
    },
    fill: "#53272c",
    d: "M 426.5,140.5 C 427.906,140.973 428.573,141.973 428.5,143.5C 427.094,143.027 426.427,142.027 426.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.31
    },
    fill: "#48262a",
    d: "M 429.5,145.5 C 430.906,145.973 431.573,146.973 431.5,148.5C 430.094,148.027 429.427,147.027 429.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.616
    },
    fill: "#541d20",
    d: "M 374.5,153.5 C 376.446,154.035 377.446,155.368 377.5,157.5C 376.026,156.564 375.026,155.23 374.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#5e1d21",
    d: "M 378.5,158.5 C 380.446,159.035 381.446,160.368 381.5,162.5C 380.026,161.564 379.026,160.23 378.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.545
    },
    fill: "#422c2f",
    d: "M 346.5,164.5 C 344.589,165.075 342.922,166.075 341.5,167.5C 342.098,164.179 343.765,163.179 346.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.361
    },
    fill: "#4c2c2f",
    d: "M 347.5,166.5 C 348.906,166.973 349.573,167.973 349.5,169.5C 348.094,169.027 347.427,168.027 347.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#563b3e",
    d: "M 210.5,169.5 C 198.134,169.248 185.801,169.748 173.5,171C 175.708,171.191 177.708,171.691 179.5,172.5C 176.022,172.816 172.688,172.316 169.5,171C 178.361,169.145 187.361,168.312 196.5,168.5C 201.346,168.501 206.012,168.834 210.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.494
    },
    fill: "#552e32",
    d: "M 339.5,169.5 C 339.573,171.027 338.906,172.027 337.5,172.5C 337.427,170.973 338.094,169.973 339.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.361
    },
    fill: "#462a2d",
    d: "M 349.5,169.5 C 350.906,169.973 351.573,170.973 351.5,172.5C 350.094,172.027 349.427,171.027 349.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.533
    },
    fill: "#5e2e32",
    d: "M 337.5,172.5 C 337.573,174.027 336.906,175.027 335.5,175.5C 335.427,173.973 336.094,172.973 337.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.392
    },
    fill: "#4b2b2f",
    d: "M 351.5,172.5 C 352.906,172.973 353.573,173.973 353.5,175.5C 352.094,175.027 351.427,174.027 351.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#5a3135",
    d: "M 199.5,175.5 C 202.228,175.171 204.562,175.837 206.5,177.5C 203.933,177.279 201.599,176.612 199.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.22
    },
    fill: "#3e2326",
    d: "M 335.5,175.5 C 335.573,177.027 334.906,178.027 333.5,178.5C 333.427,176.973 334.094,175.973 335.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.537
    },
    fill: "#5c3034",
    d: "M 353.5,175.5 C 354.906,175.973 355.573,176.973 355.5,178.5C 354.094,178.027 353.427,177.027 353.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#672e32",
    d: "M 355.5,178.5 C 357.262,179.262 358.262,180.596 358.5,182.5C 356.738,181.738 355.738,180.404 355.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.91
    },
    fill: "#662f33",
    d: "M 358.5,182.5 C 360.262,183.262 361.262,184.596 361.5,186.5C 359.738,185.738 358.738,184.404 358.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#5d1d20",
    d: "M 395.5,183.5 C 397.048,183.821 397.715,184.821 397.5,186.5C 396.599,185.71 395.932,184.71 395.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.929
    },
    fill: "#602c2f",
    d: "M 361.5,186.5 C 363.587,187.585 364.92,189.251 365.5,191.5C 363.413,190.415 362.08,188.749 361.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.424
    },
    fill: "#4d2d30",
    d: "M 302.5,186.5 C 303.906,186.973 304.573,187.973 304.5,189.5C 303.094,189.027 302.427,188.027 302.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.878
    },
    fill: "#662b30",
    d: "M 304.5,189.5 C 305.906,189.973 306.573,190.973 306.5,192.5C 305.094,192.027 304.427,191.027 304.5,189.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#772b2f",
    d: "M 244.5,192.5 C 246.989,192.241 248.656,193.241 249.5,195.5C 247.566,194.89 245.899,193.89 244.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.725
    },
    fill: "#4c2a2e",
    d: "M 367.5,193.5 C 369.262,194.262 370.262,195.596 370.5,197.5C 368.738,196.738 367.738,195.404 367.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#723035",
    d: "M 309.5,196.5 C 311.262,197.262 312.262,198.596 312.5,200.5C 310.738,199.738 309.738,198.404 309.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.141
    },
    fill: "#362427",
    d: "M 254.5,198.5 C 255.289,198.783 255.956,199.283 256.5,200C 254.934,200.765 253.601,200.598 252.5,199.5C 253.492,199.672 254.158,199.338 254.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.765
    },
    fill: "#442428",
    d: "M 374.5,201.5 C 379.167,205.5 383.5,209.833 387.5,214.5C 382.167,211.167 377.833,206.833 374.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.929
    },
    fill: "#66282c",
    d: "M 452.5,199.5 C 453.738,201.214 454.405,203.214 454.5,205.5C 452.926,203.898 452.259,201.898 452.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42
    },
    fill: "#492e32",
    d: "M 314.5,202.5 C 315.906,202.973 316.573,203.973 316.5,205.5C 315.094,205.027 314.427,204.027 314.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#602a2e",
    d: "M 118.5,205.5 C 116.898,207.074 114.898,207.741 112.5,207.5C 114.214,206.262 116.214,205.595 118.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.929
    },
    fill: "#773238",
    d: "M 112.5,207.5 C 110.485,208.924 108.152,209.59 105.5,209.5C 107.515,208.076 109.848,207.41 112.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.573
    },
    fill: "#3e2326",
    d: "M 343.5,208.5 C 345.167,209.5 346.5,210.833 347.5,212.5C 345.167,212.167 343.833,210.833 343.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.902
    },
    fill: "#5b292e",
    d: "M 104.5,209.5 C 102.898,211.074 100.898,211.741 98.5,211.5C 100.214,210.262 102.214,209.595 104.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.009
    },
    fill: "#100e0f",
    d: "M 325.5,210.5 C 325.66,212.199 325.494,213.866 325,215.5C 324.283,214.956 323.783,214.289 323.5,213.5C 324.167,212.5 324.833,211.5 325.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.902
    },
    fill: "#5d282c",
    d: "M 455.5,210.5 C 456.738,212.214 457.405,214.214 457.5,216.5C 455.926,214.898 455.259,212.898 455.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.498
    },
    fill: "#372123",
    d: "M 411.5,212.5 C 412.124,212.917 412.457,213.584 412.5,214.5C 412.253,215.713 411.586,216.38 410.5,216.5C 411.234,215.292 411.567,213.959 411.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#67272a",
    d: "M 391.5,218.5 C 393.23,219.026 394.564,220.026 395.5,221.5C 393.368,221.446 392.035,220.446 391.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#6f272b",
    d: "M 410.5,216.5 C 408.919,218.142 408.253,220.142 408.5,222.5C 405.687,219.6 406.353,217.6 410.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.573
    },
    fill: "#96565d",
    d: "M 303.5,230.5 C 302.833,230.5 302.5,230.833 302.5,231.5C 300.518,231.005 298.518,230.505 296.5,230C 299.039,229.204 301.372,229.371 303.5,230.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#150e0f",
    d: "M 242.5,229.5 C 246.806,230.066 247.139,230.732 243.5,231.5C 243.167,230.833 242.833,230.167 242.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.009
    },
    fill: "#1a1414",
    d: "M 302.5,231.5 C 302.5,230.833 302.833,230.5 303.5,230.5C 307.04,230.753 310.373,231.419 313.5,232.5C 311.15,233.11 311.483,233.444 314.5,233.5C 314.5,233.833 314.5,234.167 314.5,234.5C 310.381,233.903 306.381,232.903 302.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.141
    },
    fill: "#41272b",
    d: "M 372.5,231.5 C 371.167,232.167 369.833,232.833 368.5,233.5C 367.957,233.44 367.624,233.107 367.5,232.5C 369.045,231.548 370.712,231.215 372.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#302022",
    d: "M 314.5,233.5 C 314.5,233.167 314.5,232.833 314.5,232.5C 317.495,232.294 320.162,232.96 322.5,234.5C 319.833,234.167 317.167,233.833 314.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.878
    },
    fill: "#542a2d",
    d: "M 327.5,235.5 C 329.898,235.259 331.898,235.926 333.5,237.5C 331.214,237.405 329.214,236.738 327.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#83353b",
    d: "M 220.5,235.5 C 218.485,236.924 216.152,237.59 213.5,237.5C 215.515,236.076 217.848,235.41 220.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#422729",
    d: "M 373.5,238.5 C 378.833,241.833 383.167,246.167 386.5,251.5C 381.833,247.5 377.5,243.167 373.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.929
    },
    fill: "#5c2a2d",
    d: "M 205.5,239.5 C 204.365,241.213 202.698,241.88 200.5,241.5C 201.93,240.463 203.597,239.796 205.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#6e2f32",
    d: "M 200.5,241.5 C 199.365,243.213 197.698,243.88 195.5,243.5C 196.93,242.463 198.597,241.796 200.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.196
    },
    fill: "#342224",
    d: "M 336.5,242.5 C 338.553,242.402 340.22,243.069 341.5,244.5C 339.447,244.598 337.78,243.931 336.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.812
    },
    fill: "#5e2c30",
    d: "M 182.5,249.5 C 182.027,250.906 181.027,251.573 179.5,251.5C 179.973,250.094 180.973,249.427 182.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#701f24",
    d: "M 121.5,251.5 C 120.101,252.89 118.434,253.89 116.5,254.5C 117.953,253.175 117.619,252.342 115.5,252C 117.473,251.505 119.473,251.338 121.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.851
    },
    fill: "#682b30",
    d: "M 175.5,253.5 C 175.027,254.906 174.027,255.573 172.5,255.5C 172.973,254.094 173.973,253.427 175.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.192
    },
    fill: "#371f21",
    d: "M 372.5,253.5 C 374.027,253.427 375.027,254.094 375.5,255.5C 373.973,255.573 372.973,254.906 372.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8
    },
    fill: "#60292e",
    d: "M 170.5,256.5 C 170.027,257.906 169.027,258.573 167.5,258.5C 167.973,257.094 168.973,256.427 170.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.863
    },
    fill: "#562a2e",
    d: "M 392.5,257.5 C 394.587,258.585 395.92,260.251 396.5,262.5C 394.413,261.415 393.08,259.749 392.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#6d2b30",
    d: "M 167.5,258.5 C 167.027,259.906 166.027,260.573 164.5,260.5C 164.973,259.094 165.973,258.427 167.5,258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#4a282c",
    d: "M 381.5,258.5 C 383.027,258.427 384.027,259.094 384.5,260.5C 382.973,260.573 381.973,259.906 381.5,258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.812
    },
    fill: "#65282e",
    d: "M 164.5,260.5 C 164.027,261.906 163.027,262.573 161.5,262.5C 161.973,261.094 162.973,260.427 164.5,260.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#66272a",
    d: "M 370.5,259.5 C 372.853,260.34 374.853,261.674 376.5,263.5C 373.634,263.367 371.634,262.034 370.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#791e24",
    d: "M 294.5,263.5 C 293.833,264.833 292.833,265.833 291.5,266.5C 290.167,263.167 291.167,262.167 294.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.408
    },
    fill: "#512c2f",
    d: "M 386.5,261.5 C 388.027,261.427 389.027,262.094 389.5,263.5C 387.973,263.573 386.973,262.906 386.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.718
    },
    fill: "#62282c",
    d: "M 161.5,262.5 C 160.738,264.262 159.404,265.262 157.5,265.5C 158.262,263.738 159.596,262.738 161.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.302
    },
    fill: "#422a2c",
    d: "M 389.5,263.5 C 391.027,263.427 392.027,264.094 392.5,265.5C 390.973,265.573 389.973,264.906 389.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.835
    },
    fill: "#4c2529",
    d: "M 350.5,265.5 C 353.228,265.171 355.562,265.837 357.5,267.5C 354.933,267.279 352.599,266.612 350.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.757
    },
    fill: "#4f2a2e",
    d: "M 398.5,264.5 C 400.262,265.262 401.262,266.596 401.5,268.5C 399.738,267.738 398.738,266.404 398.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.773
    },
    fill: "#6a2a2f",
    d: "M 157.5,265.5 C 156.738,267.262 155.404,268.262 153.5,268.5C 154.262,266.738 155.596,265.738 157.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.357
    },
    fill: "#39292b",
    d: "M 392.5,265.5 C 394.404,265.738 395.738,266.738 396.5,268.5C 394.596,268.262 393.262,267.262 392.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.573
    },
    fill: "#52282b",
    d: "M 380.5,266.5 C 383.109,267.443 385.109,269.11 386.5,271.5C 383.865,270.527 381.865,268.86 380.5,266.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.69
    },
    fill: "#6c363a",
    d: "M 401.5,268.5 C 403.339,269.508 404.672,271.008 405.5,273C 402.386,273.443 400.052,272.276 398.5,269.5C 399.496,269.414 400.329,269.748 401,270.5C 401.464,269.906 401.631,269.239 401.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.894
    },
    fill: "#76292f",
    d: "M 153.5,268.5 C 152.089,270.914 150.089,272.581 147.5,273.5C 148.911,271.086 150.911,269.419 153.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.22
    },
    fill: "#392022",
    d: "M 369.5,271.5 C 371.027,271.427 372.027,272.094 372.5,273.5C 370.973,273.573 369.973,272.906 369.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.729
    },
    fill: "#4c272b",
    d: "M 386.5,271.5 C 388.587,272.585 389.92,274.251 390.5,276.5C 388.413,275.415 387.08,273.749 386.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#651e23",
    d: "M 85.5,277.5 C 84.7377,279.262 83.4044,280.262 81.5,280.5C 82.5981,279.603 82.5981,278.77 81.5,278C 82.7932,277.51 84.1266,277.343 85.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#6d2f32",
    d: "M 390.5,276.5 C 392.262,277.262 393.262,278.596 393.5,280.5C 391.738,279.738 390.738,278.404 390.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#7f252c",
    d: "M 147.5,273.5 C 144.743,277.263 141.41,280.263 137.5,282.5C 140.231,278.766 143.564,275.766 147.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#60292e",
    d: "M 379.5,288.5 C 379.573,290.027 378.906,291.027 377.5,291.5C 377.427,289.973 378.094,288.973 379.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#6b2025",
    d: "M 394.5,291.5 C 392.862,292.705 392.529,294.038 393.5,295.5C 389.634,292.712 389.968,291.379 394.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.616
    },
    fill: "#51252a",
    d: "M 128.5,291.5 C 127.92,293.749 126.587,295.415 124.5,296.5C 125.08,294.251 126.413,292.585 128.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.902
    },
    fill: "#7f292f",
    d: "M 422.5,290.5 C 422.001,293.264 420.335,294.931 417.5,295.5C 418.833,293.5 420.5,291.833 422.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#2e1f20",
    d: "M 193.5,298.5 C 193.5,297.833 193.167,297.5 192.5,297.5C 193.122,296.373 193.955,295.373 195,294.5C 195.348,296.14 194.848,297.473 193.5,298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#96252f",
    d: "M 374.5,294.5 C 373.383,296.804 372.05,298.971 370.5,301C 373.519,304.874 377.186,307.707 381.5,309.5C 376.71,308.796 372.377,307.129 368.5,304.5C 368.027,303.094 367.027,302.427 365.5,302.5C 364.355,301.207 364.689,300.041 366.5,299C 369.329,297.644 371.996,296.144 374.5,294.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2c191b",
    d: "M 64.5,297.5 C 64.573,299.027 63.9063,300.027 62.5,300.5C 62.427,298.973 63.0937,297.973 64.5,297.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.251
    },
    fill: "#4e3437",
    d: "M 398.5,297.5 C 402.466,298.162 406.466,298.495 410.5,298.5C 409.207,299.158 407.707,299.492 406,299.5C 403.179,299.592 400.679,298.926 398.5,297.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.349
    },
    fill: "#3e2427",
    d: "M 365.5,302.5 C 367.027,302.427 368.027,303.094 368.5,304.5C 366.973,304.573 365.973,303.906 365.5,302.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.435
    },
    fill: "#49272b",
    d: "M 382.5,309.5 C 385.781,309.42 388.781,310.087 391.5,311.5C 388.219,311.58 385.219,310.913 382.5,309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#63262b",
    d: "M 113.5,310.5 C 113.262,312.404 112.262,313.738 110.5,314.5C 110.738,312.596 111.738,311.262 113.5,310.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.494
    },
    fill: "#56282c",
    d: "M 110.5,314.5 C 110.573,316.027 109.906,317.027 108.5,317.5C 108.427,315.973 109.094,314.973 110.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.443
    },
    fill: "#53282b",
    d: "M 108.5,317.5 C 108.573,319.027 107.906,320.027 106.5,320.5C 106.427,318.973 107.094,317.973 108.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#752126",
    d: "M 174.5,318.5 C 174.262,320.404 173.262,321.738 171.5,322.5C 171.586,321.504 171.252,320.671 170.5,320C 171.708,319.079 173.042,318.579 174.5,318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.357
    },
    fill: "#492427",
    d: "M 106.5,320.5 C 106.573,322.027 105.906,323.027 104.5,323.5C 104.427,321.973 105.094,320.973 106.5,320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.459
    },
    fill: "#57282c",
    d: "M 103.5,325.5 C 103.573,327.027 102.906,328.027 101.5,328.5C 101.427,326.973 102.094,325.973 103.5,325.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#492327",
    d: "M 100.5,330.5 C 100.573,332.027 99.9063,333.027 98.5,333.5C 98.427,331.973 99.0937,330.973 100.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.322
    },
    fill: "#492629",
    d: "M 383.5,337.5 C 383.573,339.027 382.906,340.027 381.5,340.5C 381.427,338.973 382.094,337.973 383.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#5d2427",
    d: "M 176.5,338.5 C 176.741,340.898 176.074,342.898 174.5,344.5C 174.595,342.214 175.262,340.214 176.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#6d2b2f",
    d: "M 378.5,345.5 C 378.262,347.404 377.262,348.738 375.5,349.5C 375.738,347.596 376.738,346.262 378.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#6d2b30",
    d: "M 375.5,349.5 C 375.262,351.404 374.262,352.738 372.5,353.5C 372.738,351.596 373.738,350.262 375.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#722429",
    d: "M 266.5,350.5 C 268.008,352.181 269.008,354.181 269.5,356.5C 267.087,355.32 266.087,353.32 266.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#7d2e30",
    d: "M 368.5,357.5 C 367.753,360.362 366.086,362.362 363.5,363.5C 364.701,361.091 366.367,359.091 368.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.467
    },
    fill: "#53282c",
    d: "M 273.5,364.5 C 274.906,364.973 275.573,365.973 275.5,367.5C 274.094,367.027 273.427,366.027 273.5,364.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.886
    },
    fill: "#5e2428",
    d: "M 275.5,367.5 C 277.262,368.262 278.262,369.596 278.5,371.5C 276.738,370.738 275.738,369.404 275.5,367.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#551c1e",
    d: "M 83.5,370.5 C 85.4456,371.035 86.4456,372.368 86.5,374.5C 85.0256,373.564 84.0256,372.23 83.5,370.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.808
    },
    fill: "#6b282e",
    d: "M 357.5,369.5 C 355.761,372.243 353.427,374.243 350.5,375.5C 352.239,372.757 354.573,370.757 357.5,369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.886
    },
    fill: "#6b2b30",
    d: "M 350.5,375.5 C 349.415,377.587 347.749,378.92 345.5,379.5C 346.585,377.413 348.251,376.08 350.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.667
    },
    fill: "#5c292d",
    d: "M 345.5,379.5 C 344.738,381.262 343.404,382.262 341.5,382.5C 342.262,380.738 343.596,379.738 345.5,379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.725
    },
    fill: "#58262c",
    d: "M 341.5,382.5 C 341.027,383.906 340.027,384.573 338.5,384.5C 338.973,383.094 339.973,382.427 341.5,382.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#632023",
    d: "M 293.5,384.5 C 295.027,384.427 296.027,385.094 296.5,386.5C 294.877,387.491 293.877,386.824 293.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2b1516",
    d: "M 95.5,386.5 C 96.9063,386.973 97.573,387.973 97.5,389.5C 96.0937,389.027 95.427,388.027 95.5,386.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#892028",
    d: "M 416.5,387.5 C 415.2,390.432 413.2,392.766 410.5,394.5C 409.677,389.661 411.677,387.327 416.5,387.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.792
    },
    fill: "#5e262a",
    d: "M 327.5,391.5 C 327.027,392.906 326.027,393.573 324.5,393.5C 324.973,392.094 325.973,391.427 327.5,391.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.573
    },
    fill: "#3b1619",
    d: "M 100.5,393.5 C 101.833,393.5 102.5,394.167 102.5,395.5C 101.5,395.167 100.833,394.5 100.5,393.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2d1719",
    d: "M 409.5,395.5 C 409.573,397.027 408.906,398.027 407.5,398.5C 407.427,396.973 408.094,395.973 409.5,395.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#36191d",
    d: "M 109.5,402.5 C 111.833,404.167 113.833,406.167 115.5,408.5C 112.5,407.5 110.5,405.5 109.5,402.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#9b202b",
    d: "M 401.5,404.5 C 399.5,407.167 397.167,409.5 394.5,411.5C 393.333,410.228 392.499,408.894 392,407.5C 393.707,408.138 395.54,408.138 397.5,407.5C 398.309,405.027 398.642,402.694 398.5,400.5C 399.934,401.588 400.934,402.922 401.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.729
    },
    fill: "#4b1b1f",
    d: "M 120.5,413.5 C 122.404,413.738 123.738,414.738 124.5,416.5C 122.596,416.262 121.262,415.262 120.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#161011",
    d: "M 134.5,421.5 C 134.289,423.424 133.623,423.757 132.5,422.5C 133.167,422.167 133.833,421.833 134.5,421.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#771e24",
    d: "M 375.5,427.5 C 374.055,429.063 372.389,430.396 370.5,431.5C 370.5,430.167 370.5,428.833 370.5,427.5C 372.167,427.5 373.833,427.5 375.5,427.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.835
    },
    fill: "#53272b",
    d: "M 202.5,460.5 C 204.898,460.259 206.898,460.926 208.5,462.5C 206.214,462.405 204.214,461.738 202.5,460.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.533
    },
    fill: "#4f2b2f",
    d: "M 214.5,463.5 C 217.781,463.42 220.781,464.087 223.5,465.5C 220.219,465.58 217.219,464.913 214.5,463.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d4e5a567f496d868c94d0c9f7a59d526.svg";
export { ForwardRef as ReactComponent };